'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.fetchCupidAndLoadExecutor = fetchCupidAndLoadExecutor;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _effects = require('redux-saga/effects');

var _redux = require('@adparlor-devops/js-anvil/redux');

var _constants = require('../../events/constants');

var _constants2 = require('../../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fetchCupidAndLoadExecutor].map(_regenerator2.default.mark);

function fetchCupidAndLoadExecutor(_ref) {
  var payload = _ref.payload;
  var cupidKey, successDeserializer;
  return _regenerator2.default.wrap(function fetchCupidAndLoadExecutor$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          cupidKey = payload.cupidKey;

          successDeserializer = function successDeserializer(data) {
            var dataObj = JSON.parse(data.value);
            var startTime = (0, _moment2.default)(dataObj.start_date);
            var endTime = (0, _moment2.default)(dataObj.end_date);

            return {
              filterParams: {
                filterRange: "DATE_RANGE",
                paginationSize: _constants2.AGGREGATE_EVENTS_PAGINATION_SIZE,
                startTime: startTime,
                endTime: endTime
              }
            };
          };

          _context.next = 4;
          return (0, _effects.put)({
            type: _redux.CUPID_PAYLOAD_FETCH,
            payload: {
              cupidKey: cupidKey,
              successAction: _constants.FETCH_AGGREGATE_EVENTS,
              successDeserializer: successDeserializer
            }
          });

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/store/cupid/sagas/executors.js
// module id = 3443
// module chunks = 2